import { ApolloError } from '@apollo/client'
import React, { createContext } from 'react'

import { GetCustomerOrdersQuery, Maybe } from '../../graphql/camel'

export interface SortedItem {
  readonly sku: string
  readonly date: Date
  readonly count: number
}

export type GetCustomerOrdersQueryOrders =
  | Maybe<NonNullable<GetCustomerOrdersQuery['getCustomerOrders']>['orders']>
  | undefined

export type ReorderDispatchAction =
  | {
      type: 'customerOrdersUpdated'
      readonly orders: GetCustomerOrdersQueryOrders
    }
  | {
      type: 'customerOrdersError'
      readonly error: ApolloError | Error
    }

export interface ReorderContextValue {
  readonly itemsByDate: SortedItem[]
  readonly itemsByCount: SortedItem[]
  readonly dispatch: React.Dispatch<ReorderDispatchAction>
  readonly loading: boolean
  readonly error: ApolloError | Error | undefined
}

export const ReorderContext = createContext<ReorderContextValue>({
  itemsByDate: [],
  itemsByCount: [],
  dispatch: () => {
    // empty initializer
  },
  loading: false,
  error: undefined,
})
